import useSite from '~/client/hooks/useSite';
import internationalCallingCodes from '../../../FormSelect/InternationalCallingCodes';
import getInternationalCallingCodes from '../helpers/getInternationalCallingCodes';

const useCallingCodes = () => {
  const { site } = useSite();
  const primaryOptions: SelectOption[] = getInternationalCallingCodes(
    true,
    site,
  );
  const secondaryOptions: SelectOption[] = getInternationalCallingCodes(
    false,
    site,
  );

  const getCountryCallingCode = (countryCode: string) =>
    internationalCallingCodes?.[countryCode]?.code.toString();

  const formatPhoneCallingCode = ({
    callingCode,
    country,
    phone,
  }: {
    callingCode: string;
    country: string;
    phone: string;
  }) => {
    const code = getCountryCallingCode(country) || '';
    if (callingCode && code) {
      return { phone: phone?.replace(`+${code}`, ''), code };
    }
    return { phone, code: callingCode };
  };

  return {
    primaryOptions,
    secondaryOptions,
    getCountryCallingCode,
    formatPhoneCallingCode,
  };
};

export default useCallingCodes;
